import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';
import type { BalanceItem } from '@/types/residents/lease';

export interface LeaseBalanceResponse {
  balanceDue: number;
  accountCredit: number;
  balanceItems: BalanceItem[];
}

export const leasesApi = createApi({
  reducerPath: 'leasesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['LeaseBalance'],
  endpoints: (builder) => ({
    getLease: builder.query<
      any,
      { leaseId: number; includeTransactions: boolean; includePayments: boolean; includePending?: boolean }
    >({
      query: ({ leaseId, includeTransactions, includePayments, includePending = true }) => ({
        // Note: includeBalance removed - balance is fetched via the dedicated
        // /api/v4/leases/:id/balance endpoint
        url: `/api/v4/leases/${leaseId}?includeTransactions=${includeTransactions}&includePayments=${includePayments}&includePending=${includePending}`,
        method: 'GET',
      }),
      // Survive screen unmount/remount so navigating back to transaction
      // history doesn't re-trigger the slow lease+ledger fetch.
      keepUnusedDataFor: 300,
    }),

    getLeaseBalance: builder.query<LeaseBalanceResponse, number>({
      query: (leaseId) => ({
        url: `/api/v4/leases/${leaseId}/balance`,
        method: 'GET',
      }),
      transformResponse: (resp: any) => resp?.response,
      providesTags: (_result, _error, leaseId) => [{ type: 'LeaseBalance', id: leaseId }],
    }),
  }),
});

export const { useGetLeaseQuery, useLazyGetLeaseQuery, useGetLeaseBalanceQuery } = leasesApi;


